import React, { useEffect, useState } from "react";
import { useAppSelector } from "@shared/ui";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

import "./Login.css";
import { UserRole } from "@shared/ui";

import LoginForm from "./components/LoginForm";
import ForgotPasswordForm from "./components/ForgotPasswordForm";

const Login: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const currUser = useAppSelector((store) => store.user.value);

  const [resetPassword, setResetPassword] = useState(false);

  useEffect(() => {
    if (currUser) {
      if (currUser.role == UserRole.SuperAdmin) {
        navigate("/customers");
      } else {
        navigate("/dashboard");
      }
    }
  }, [currUser]);

  return (
    <div className="form-page">
      <div className="form-wrapper">
        <h1 className="text-center">{!resetPassword ? t("login.title") : t("login.forgotPasswordTitle")}</h1>
        {!resetPassword ? <LoginForm setResetPassword={setResetPassword} /> : <ForgotPasswordForm setResetPassword={setResetPassword} />}

        {/*<ResetPasswordForm />*/}

      </div>
    </div>
  );
};

export default Login;
